import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/channel-info/channel-info.tsx");
